import { render, staticRenderFns } from "./zMensagem.vue?vue&type=template&id=4cacac70&"
import script from "./zMensagem.vue?vue&type=script&lang=js&"
export * from "./zMensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports